import { render, staticRenderFns } from "./FlatGuestBox.vue?vue&type=template&id=5382507f&scoped=true&"
import script from "./FlatGuestBox.vue?vue&type=script&lang=js&"
export * from "./FlatGuestBox.vue?vue&type=script&lang=js&"
import style0 from "./FlatGuestBox.vue?vue&type=style&index=0&id=5382507f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382507f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5382507f')) {
      api.createRecord('5382507f', component.options)
    } else {
      api.reload('5382507f', component.options)
    }
    module.hot.accept("./FlatGuestBox.vue?vue&type=template&id=5382507f&scoped=true&", function () {
      api.rerender('5382507f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N2sebWrya0Xw/JS/comp/FlatGuestBox.vue"
export default component.exports